import React, { useContext } from "react";

import {
  Flex,
  Container,
  Text,
  Box,
  TransparentButton,
  Divider,
} from "flicket-ui";

import { useRouter } from "next/router";
import {
  Layout,
  Footer,
  BottomBar,
  Menu,
  Seo,
  Icon,
  ContentContainer,
  SlateRenderer,
} from "~components";
import { BaseContext } from "~context";

const TermsAndConditions = () => {
  const router = useRouter();
  const { organization } = useContext(BaseContext);

  return (
    <>
      <Seo
        title="General Terms and Conditions"
        description="General Terms and Conditions"
      />
      <Menu />
      <Flex flexDirection="column" flex={1}>
        <Box d={{ _: "block", md: "none" }}>
          <Flex px={2} py={3}>
            <TransparentButton mr={2} onClick={() => router.back()}>
              <Icon icon="chevron-left" fontSize={6} color="N800" />
            </TransparentButton>
            <Text
              lineHeight="normal"
              fontSize={6}
              fontWeight="extraBold"
              color="N800"
            >
              General Terms and Conditions
            </Text>
          </Flex>
          <Divider />
        </Box>
        <Flex
          flexDirection="column"
          flex={1}
          maxH={{ _: "calc(100vh - 73px)", md: "unset" }}
          overflowY={{ _: "auto", md: "visible" }}
        >
          <Layout layoutType="overlay">
            <ContentContainer variant="content">
              <Flex flexDir="column" pb={{ _: 2, md: 0 }} flex="1">
                <Box
                  d={{ _: "none", md: "block" }}
                  width="100%"
                  maxWidth="1248px"
                  pl={4}
                  mx={"auto" as any}
                >
                  <TransparentButton onClick={() => router.back()}>
                    <Flex alignItems="center" opacity="inherit">
                      <Icon icon="chevron-left" fontSize={5} color="white" />
                      <Text
                        color="white"
                        fontWeight="extraBold"
                        fontSize={3}
                        lineHeight="medium"
                        ml="3/4"
                      >
                        Back
                      </Text>
                    </Flex>
                  </TransparentButton>
                  <Text
                    color="white"
                    fontWeight="heavy"
                    fontSize={9}
                    lineHeight={"56px" as any}
                    my={1}
                  >
                    General Terms and Conditions
                  </Text>
                </Box>
                <Container
                  mb={{ _: 0, md: 10 }}
                  innerProps={{ minHeight: { _: 0, md: "320px" } }}
                >
                  {organization?.termsAndConditions ? (
                    <SlateRenderer value={organization?.termsAndConditions} />
                  ) : (
                    <Text mb={{ _: 1, md: 2 }}>
                      General Terms and Conditions coming soon!
                    </Text>
                  )}
                  <Text
                    color="white"
                    fontWeight="medium"
                    fontSize={3}
                    lineHeight="normal"
                    my={1}
                  >
                    Cookie policy
                  </Text>
                </Container>
              </Flex>
              <Footer />
            </ContentContainer>
          </Layout>
        </Flex>
      </Flex>
      <BottomBar />
    </>
  );
};

export default TermsAndConditions;
